import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import NProgressApp from 'utils/nprogress';
import introspectionQueryResultData from './fragmentTypes';

// For UNION in graphql
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: process.env.GRAPHQL_HOST
});

// Cache implementation
const cache = new InMemoryCache({ fragmentMatcher });

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache
});

export const apolloClientQuery = (query, variables = {}, loading = true) => {
  if (loading) NProgressApp.start();
  return new Promise((resolve, reject) => {
    apolloClient
      .query({ query, variables })
      .then(({ data }) => {
        if (loading) NProgressApp.done();
        resolve(data);
      })
      .catch(err => {
        if (loading) NProgressApp.done();
        reject(err);
      });
  });
};

export const apolloClientMutate = (mutation, payload) => {
  NProgressApp.start();
  return new Promise((resolve, reject) => {
    apolloClient
      .mutate({
        mutation,
        variables: payload
      })
      .then(({ data }) => {
        NProgressApp.done();
        resolve(data);
      })
      .catch(err => {
        NProgressApp.done();
        reject(err);
      });
  });
};
